// vue directives
import Vue from 'vue'
import store from '../store/index'

Vue.directive('focus', {
  inserted: function (el) {
    el.focus()
  }
})

Vue.directive('auth', {
  inserted: function (el, binding, vnode) {
    if (!store.getters.permissionAction(binding.value)) {
      el.parentNode.removeChild(el)
    }
  }
})
